import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TermsConditionsComponent } from '../../../pages/terms-conditions/terms-conditions.component'
import { CriteriaComponent } from '../../../pages/criteria/criteria.component'

@Component({
  standalone: false,
  selector: 'app-ancillary-nav',
  templateUrl: './ancillary-nav.component.html',
  styleUrls: ['./ancillary-nav.component.scss']
})

export class AncillaryNavComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  }

  openTermsConditionsDialog(){
    const dialogRef = this.dialog.open(TermsConditionsComponent);

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(`Dialog closed: ${result}`);
    });
  }

  openCriteriaDialog(){
    const dialogRef = this.dialog.open(CriteriaComponent);



    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(`Dialog closed: ${result}`);
    });
  }

}
